<template>
    <div>
        <div class="range-header">
            {{lbl.range}}
        </div>

        <div>
            <b-slider v-model="price" @change="changeRangePrice()" :min="0" :max="999999" :step="1" rounded>
            </b-slider>
        </div>

        <div class="input-price">
            <InputNumber
                ref="priceLow"
                v-model="price[0]"
                inputId="input-price-low"
                key="input-price-low"
                :inputLbl="lbl.lowPrice"
                :inputMinLength="1"
                :inputMaxLength="6"
                :isFirstSave="true"
                :isShowErrorLbl="true"
                :errorInfo="errorInfo[0]"
                @input="changeRangePrice()"
            ></InputNumber>
            <InputNumber
                ref="priceHigh"
                v-model="price[1]"
                inputId="input-price-high"
                key="input-price-high"
                :inputLbl="lbl.highPrice"
                :inputMinLength="1"
                :inputMaxLength="6"
                :isFirstSave="true"
                :isShowErrorLbl="true"
                :errorInfo="errorInfo[1]"
                @input="changeRangePrice()"
            ></InputNumber>
        </div>
    </div>
</template>

<script>
import Locale from "@/helper/locale/Locale.js";
// components
import InputNumber from "./Number.vue";
// helper
import FormHelper from "@/helper/FormHelper.js";

export default {
    components: {
        InputNumber,
    },
    data() {
        return {
            lbl: Locale.getLbl().searchList.sidebar,
            price: [0, 999999],
            errorInfo: FormHelper.genErrorInfo(2),
        }
    },
    created () {
        this.changeRangePrice();
    },
    computed: {

    },
    methods: {
        changeRangePrice() {
            this.$emit('changeRangePrice', this.price)
        },
        clearValue() {
            this.price = [0, 999999]
            this.$emit('changeRangePrice', this.price)
        }
    },
    watch: {
        price(newValue) {
            if(newValue){
                this.$refs.priceLow.setValue(newValue[0])
                this.$refs.priceHigh.setValue(newValue[1])
            }
            // if(newValue[1] === 0){
            //     this.price = [0, 999999]
            //     this.$refs.priceLow.setValue(this.price[0])
            //     this.$refs.priceHigh.setValue(this.price[1])
            // }
        },
    },
}
</script>

<style lang="scss" scoped>
    @import "@/style/base/base.scss";
    @import "./RangePrice.scss";
</style>